function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["id", "x", "y"],
  _excluded2 = ["x", "y", "shape", "msg", "color"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import olSourceVector from 'ol/source/Vector';
import olLayerVector from 'ol/layer/Vector';
import olFeature from 'ol/Feature';
import * as olGeom from 'ol/geom';
import '../../request/AddMarkerRequest';
import '../../request/AddMarkerRequestHandler';
import '../../request/RemoveMarkersRequest';
import '../../request/RemoveMarkersRequestHandler';
import '../../request/MarkerVisibilityRequest';
import '../../request/MarkerVisibilityRequestHandler';
import '../../event/AfterAddMarkerEvent';
import '../../event/MarkerClickEvent';
import '../../event/AfterRemoveMarkersEvent';
import { showAddMarkerPopup } from './view/MarkersForm';
import { showMarkerPopup } from './view/MarkerPopup';
import { ID_PREFIX, PLUGIN_NAME, TOOL_GROUP, DEFAULT_STYLE, GEOMETRY_TYPE, DEFAULT_DATA, SEPARATORS } from './constants';

/**
 * @class Oskari.mapframework.mapmodule.MarkersPlugin
 * Provides marker functionality for the map.
 */
Oskari.clazz.define('Oskari.mapframework.mapmodule.MarkersPlugin',
/**
 * @method create called automatically on construction
 * @static
 */
function () {
  var _this = this;
  this._clazz = 'Oskari.mapframework.mapmodule.MarkersPlugin';
  this._name = PLUGIN_NAME;
  this._hiddenMarkers = {}; // id: olFeature
  this._styleData = {}; // store values as it's hard to get them from feature's ol style

  this.buttons = null;
  this.markerPopupControls = null;
  this._buttonsAdded = false;
  this._showAddMarkerPopupOnMapClick = false;

  // Show the marker button
  this._layer = undefined;
  this.log = Oskari.log(PLUGIN_NAME);
  this.popupControls = null;
  this.popupCleanup = function () {
    var restartTool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    if (_this.popupControls) {
      _this.popupControls.close();
      _this._showAddMarkerPopupOnMapClick = true;
    }
    _this.popupControls = null;
    if (!_this.markerPopupControls && restartTool) {
      _this.startMarkerAdd();
    }
  };
}, {
  /**
   * @method hasUI
   * @return {Boolean} true
   * This plugin has an UI so always returns true
   */
  hasUI: function hasUI() {
    return true;
  },
  _createEventHandlers: function _createEventHandlers() {
    var _this2 = this;
    return {
      MapClickedEvent: function MapClickedEvent(event) {
        return _this2._mapClick(event);
      },
      'Toolbar.ToolbarLoadedEvent': function ToolbarToolbarLoadedEvent() {
        return _this2._registerTools();
      },
      'Toolbar.ToolSelectedEvent': function ToolbarToolSelectedEvent(event) {
        if (event.getToolId() !== 'addMarker' && event.getSticky()) {
          if (_this2.popupControls) {
            _this2.popupCleanup(false);
          }
          _this2.stopMarkerAdd(false);
        }
      }
    };
  },
  _createRequestHandlers: function _createRequestHandlers() {
    var me = this;
    var sandbox = me.getSandbox();
    return {
      'MapModulePlugin.AddMarkerRequest': Oskari.clazz.create('Oskari.mapframework.bundle.mapmodule.request.AddMarkerRequestHandler', sandbox, me),
      'MapModulePlugin.RemoveMarkersRequest': Oskari.clazz.create('Oskari.mapframework.bundle.mapmodule.request.RemoveMarkersRequestHandler', sandbox, me),
      'MapModulePlugin.MarkerVisibilityRequest': Oskari.clazz.create('Oskari.mapframework.bundle.mapmodule.request.MarkerVisibilityRequestHandler', sandbox, me)
    };
  },
  /**
   * @method register
   * Interface method for the plugin protocol
   */
  register: function register() {
    this.getMapModule().setLayerPlugin('markers', this);
  },
  /**
   * @method unregister
   * Interface method for the plugin protocol
   */
  unregister: function unregister() {
    this.getMapModule().setLayerPlugin('markers', null);
  },
  /**
   * @private @method _startPluginImpl
   * Interface method for the plugin protocol.
   * Creates the base marker layer.
   */
  _startPluginImpl: function _startPluginImpl() {
    var _this3 = this;
    this.buttons = {
      addMarker: {
        iconCls: 'marker-share',
        tooltip: this.getMsg('tooltip'),
        sticky: true,
        callback: function callback() {
          return _this3.startMarkerAdd();
        }
      }
    };
    // Register marker tools
    this._registerTools();
  },
  /**
   * Requests the tools to be added to the toolbar.
   *
   * @method registerTool
   */
  _registerTools: function _registerTools() {
    var _this4 = this;
    var _this$getConfig = this.getConfig(),
      markerButton = _this$getConfig.markerButton;
    if (this._buttonsAdded || markerButton === false) {
      return;
    }
    var sandbox = this.getSandbox();
    if (!sandbox.hasHandler('Toolbar.AddToolButtonRequest')) {
      // Couldn't get the request, toolbar not loaded
      return;
    }
    var reqBuilder = Oskari.requestBuilder('Toolbar.AddToolButtonRequest');
    Object.keys(this.buttons).forEach(function (btnName) {
      var request = reqBuilder(btnName, TOOL_GROUP, _this4.buttons[btnName]);
      sandbox.request(_this4.getName(), request);
    });
    this._buttonsAdded = true;
  },
  /**
   * Handles generic map click
   * @private
   * @param  {Oskari.mapframework.bundle.mapmodule.event.MapClickedEvent} event map click
   */
  _mapClick: function () {
    var _mapClick2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(event) {
      var _this5 = this;
      var _pixels, pixels, features, _iterator, _step, feature, _event$getLonLat, lon, lat, onAdd, onDelete, markerData;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            this.keepToolActive = true;
            if (this.markerPopupControls) {
              this.closeMarkerPopup();
            }
            this.keepToolActive = false;
            if (this._showAddMarkerPopupOnMapClick) {
              _context.n = 1;
              break;
            }
            // get markers from layer by pixel so we get result based on visualization and not the coordinate for the point
            _pixels = [event.getMouseX(), event.getMouseY()];
            this.getMarkersLayer().getFeatures(_pixels).then(function (featureList) {
              return featureList.forEach(function (feature) {
                return _this5._markerClicked(feature.getId());
              });
            });
            return _context.a(2);
          case 1:
            // get markers from layer by pixel so we get result based on visualization and not the coordinate for the point
            pixels = [event.getMouseX(), event.getMouseY()];
            _context.n = 2;
            return this.getMarkersLayer().getFeatures(pixels);
          case 2:
            features = _context.v;
            _iterator = _createForOfIteratorHelper(features);
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                feature = _step.value;
                this._markerClicked(feature.getId());
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            if (this._showAddMarkerPopupOnMapClick) {
              _context.n = 3;
              break;
            }
            return _context.a(2);
          case 3:
            // adding a marker
            _event$getLonLat = event.getLonLat(), lon = _event$getLonLat.lon, lat = _event$getLonLat.lat;
            this._showAddMarkerPopupOnMapClick = false;
            onAdd = function onAdd(style, marker) {
              var coord = marker ? [marker.x, marker.y] : [lon, lat];
              _this5.popupCleanup();
              _this5._addMarkerFromPopup(coord, style, marker === null || marker === void 0 ? void 0 : marker.id);
            };
            onDelete = function onDelete(marker) {
              _this5.popupCleanup();
              _this5.removeMarkers(marker.id);
            };
            if (features.length > 0) {
              markerData = this._featureToMarkerData(features[0]);
              this.popupControls = showAddMarkerPopup(onAdd, onDelete, this.popupCleanup, markerData);
            } else {
              this.popupControls = showAddMarkerPopup(onAdd, onDelete, this.popupCleanup);
            }
          case 4:
            return _context.a(2);
        }
      }, _callee, this);
    }));
    function _mapClick(_x) {
      return _mapClick2.apply(this, arguments);
    }
    return _mapClick;
  }(),
  /**
   * Called when a marker has been clicked.
   * @method  _markerClicked
   * @private
   * @param  {String} markerId which was clicked
   */
  _markerClicked: function _markerClicked(markerId) {
    var clickEvent = Oskari.eventBuilder('MarkerClickEvent')(markerId);
    this.getSandbox().notifyAll(clickEvent);
  },
  getMarkersLayer: function getMarkersLayer() {
    if (!this._layer) {
      this._layer = new olLayerVector({
        title: 'Markers',
        source: new olSourceVector()
      });
      this.getMapModule().addOverlayLayer(this._layer, 'markers');
    }
    return this._layer;
  },
  getOLMapLayers: function getOLMapLayers() {
    return [];
  },
  getMapMarkerBounds: function getMapMarkerBounds() {
    return this.getMarkersLayer().getSource().getExtent();
  },
  closeMarkerPopup: function closeMarkerPopup() {
    if (this.markerPopupControls) {
      this.markerPopupControls.close();
    }
    this.markerPopupControls = null;
    if (!this.keepToolActive) {
      this.stopMarkerAdd();
    }
  },
  /**
   * Activate the "add marker mode" on map.
   */
  startMarkerAdd: function startMarkerAdd() {
    var _this6 = this;
    if (Oskari.util.isMobile()) {
      Oskari.dom.showNavigation(false);
    }
    this.enableGfi(false);
    this._showAddMarkerPopupOnMapClick = true;
    if (!this.markerPopupControls) {
      this.markerPopupControls = showMarkerPopup(function () {
        return _this6.removeMarkers();
      }, function () {
        return _this6.closeMarkerPopup();
      });
    }
    this.getMapModule().setCursorStyle('crosshair', this.getName());
  },
  /**
   * Stops the marker location selector
   */
  stopMarkerAdd: function stopMarkerAdd() {
    var selectDefault = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    this.enableGfi(true);
    this._showAddMarkerPopupOnMapClick = false;
    if (this.markerPopupControls) {
      this.closeMarkerPopup();
    }
    if (this.popupControls) {
      this.popupCleanup();
    }
    this.getMapModule().setCursorStyle('', this.getName());
    if (!selectDefault) {
      return;
    }
    // ask toolbar to select default tool if available
    var toolbarRequest = Oskari.requestBuilder('Toolbar.SelectToolButtonRequest');
    if (toolbarRequest) {
      this.getSandbox().request(this, toolbarRequest());
    }
  },
  addMapMarker: function addMapMarker(markerData, markerId) {
    // Combine default values with given values
    var _this$_getSanitizedMa = this._getSanitizedMarker(markerData, markerId),
      id = _this$_getSanitizedMa.id,
      x = _this$_getSanitizedMa.x,
      y = _this$_getSanitizedMa.y,
      styleData = _objectWithoutProperties(_this$_getSanitizedMa, _excluded);
    if (!id) {
      // validation failed
      this.log.warn('Error while adding marker');
      return;
    }
    this._styleData[id] = styleData;
    var style = this._getStyleFromMarkerData(styleData);
    this._addMarkerToMap(id, [x, y], style);
  },
  removeMarkers: function removeMarkers(id) {
    if (id) {
      delete this._hiddenMarkers[id];
      delete this._styleData[id];
      this._removeMarkerFromMap(id);
    } else {
      // remove all
      this.getMarkersLayer().getSource().clear();
      this._hiddenMarkers = {};
      this._styleData = {};
    }
    var removeEvent = Oskari.eventBuilder('AfterRemoveMarkersEvent')(id);
    this.getSandbox().notifyAll(removeEvent);
  },
  _getSanitizedMarker: function _getSanitizedMarker(markerData, markerId) {
    var x = markerData.x,
      y = markerData.y,
      shape = markerData.shape,
      msg = markerData.msg,
      color = markerData.color,
      other = _objectWithoutProperties(markerData, _excluded2);
    // Validation: coordinates are needed
    if (typeof x === 'undefined' || typeof y === 'undefined') {
      this.log.warn('Undefined coordinate in', markerData);
      return {};
    }
    // generate id if not provided
    var id = markerId || ID_PREFIX + Oskari.getSeq(this.getName()).nextVal();
    var sanitized = _objectSpread({
      id: id,
      x: x,
      y: y
    }, DEFAULT_DATA);
    if (typeof shape !== 'undefined') {
      sanitized.shape = isNaN(shape) ? shape : parseInt(shape);
    }
    if (msg) {
      sanitized.msg = decodeURIComponent(msg);
    }
    if (color) {
      sanitized.color = color.charAt(0) === '#' ? color.substring(1) : color;
    }
    Object.keys(other).forEach(function (key) {
      var value = other[key];
      if (typeof value !== 'undefined') {
        sanitized[key] = value;
      }
    });
    return sanitized;
  },
  /**
   * Close enough "backwards compatibility" workaround for marker size when using external graphic/svg as icon.
   * If the requested size is below 10 -> use the formula used pre-2.7 to calculate size.
   * Otherwise keep the requested size (documented as pixel size).
   * @param {Number} requestedSize pixel value or previously supported value of 1-5 like for built-in symbols. Cut off point for logic is at 10.
   */
  __workaroundForBackwardsCompatibilitySize: function __workaroundForBackwardsCompatibilitySize(requestedSize) {
    if (typeof requestedSize === 'number' && requestedSize < 10) {
      var mapmodule = this.getMapModule();
      if (mapmodule && typeof mapmodule.getPixelForSize === 'function') {
        return mapmodule.getPixelForSize(requestedSize);
      }
    }
    return requestedSize;
  },
  _getStyleFromMarkerData: function _getStyleFromMarkerData(markerData) {
    var style = jQuery.extend(true, {}, DEFAULT_STYLE);
    var color = markerData.color,
      shape = markerData.shape,
      size = markerData.size,
      msg = markerData.msg,
      offsetX = markerData.offsetX,
      offsetY = markerData.offsetY;
    style.image.fill.color = '#' + color;
    style.image.shape = shape;
    style.text.labelText = msg;
    // use pixel size if shape is svg or url
    if (typeof shape === 'string') {
      style.image.sizePx = this.__workaroundForBackwardsCompatibilitySize(size);
    } else {
      style.image.size = size;
    }
    if (typeof offsetX !== 'undefined') {
      style.image.offsetX = offsetX;
    }
    if (typeof offsetY !== 'undefined') {
      style.image.offsetY = offsetY;
    }
    return style;
  },
  _addMarkerFromPopup: function _addMarkerFromPopup(coord, style, existingId) {
    var id = existingId || ID_PREFIX + Oskari.getSeq(this.getName()).nextVal();
    var image = style.image,
      text = style.text;
    var fill = image.fill,
      shape = image.shape,
      size = image.size;
    var styleData = {
      color: fill.color.substring(1),
      shape: shape,
      size: size,
      msg: text.labelText
    };
    this._styleData[id] = styleData;
    this._addMarkerToMap(id, coord, style);
  },
  _addMarkerToMap: function _addMarkerToMap(id, coord, style) {
    var layerSource = this.getMarkersLayer().getSource();
    var olStyle = this.getMapModule().getStyle(style, GEOMETRY_TYPE);
    var feature = new olFeature(new olGeom.Point(coord));
    feature.setId(id);
    feature.setStyle(olStyle);
    if (layerSource.hasFeature(feature)) {
      // ol doesn't add features with same id, update existing
      var existing = layerSource.getFeatureById(id);
      existing.setGeometry(new olGeom.Point(coord));
      existing.setStyle(olStyle);
    } else {
      layerSource.addFeature(feature);
    }
    var data = this._featureToMarkerData(feature);
    var addEvent = Oskari.eventBuilder('AfterAddMarkerEvent')(data, id);
    this.getSandbox().notifyAll(addEvent);
  },
  _removeMarkerFromMap: function _removeMarkerFromMap(id) {
    var layerSource = this.getMarkersLayer().getSource();
    var feature = layerSource.getFeatureById(id);
    if (feature) {
      layerSource.removeFeature(feature);
    }
  },
  _featureToMarkerData: function _featureToMarkerData(feature) {
    var id = feature.getId();
    var coord = feature.getGeometry().getCoordinates();
    var styleData = this._styleData[id];
    return _objectSpread({
      id: id,
      x: coord[0],
      y: coord[1]
    }, styleData);
  },
  /**
   * Change map marker visibility.
   * @method  @public changeMapMarkerVisibility
   * @param  {Boolean} visible  visibility is marker visible or not.
   * @param  {String} id  optional marker id for marker to change it's visibility, all markers visibility changed if not given.
   */
  changeMapMarkerVisibility: function changeMapMarkerVisibility(visible, id) {
    var _this7 = this;
    var layerSource = this.getMarkersLayer().getSource();
    var update = function update(feature) {
      if (!feature) {
        // not found for requested id (invalid id or feature is visible/hidden already)
        return;
      }
      var fid = feature.getId();
      if (visible) {
        layerSource.addFeature(feature);
        delete _this7._hiddenMarkers[fid];
      } else {
        _this7._hiddenMarkers[fid] = feature;
        layerSource.removeFeature(feature);
      }
    };
    if (id) {
      var feature = visible ? this._hiddenMarkers[id] : layerSource.getFeatureById(id);
      update(feature);
    } else {
      var features = visible ? Object.values(this._hiddenMarkers) : layerSource.getFeatures();
      features.forEach(function (f) {
        return update(f);
      });
    }
  },
  /**
   * @method enableGfi
   * Enables/disables the gfi functionality
   * @param {Boolean} blnEnable true to enable, false to disable
   */
  enableGfi: function enableGfi(blnEnable) {
    var sandbox = this.getSandbox();
    var gfiReqBuilder = Oskari.requestBuilder('MapModulePlugin.GetFeatureInfoActivationRequest');
    var hiReqBuilder = Oskari.requestBuilder('WfsLayerPlugin.ActivateHighlightRequest');

    // enable or disable gfi requests
    if (gfiReqBuilder) {
      sandbox.request(this.getName(), gfiReqBuilder(blnEnable));
    }

    // enable or disable wfs highlight
    if (hiReqBuilder) {
      sandbox.request(this.getName(), hiReqBuilder(blnEnable));
    }
  },
  /**
   * @method setState
   * Set the bundle state
   * @param {Object} state bundle state as JSON
   */
  setState: function setState(state) {
    var _this8 = this;
    // Clear state
    this.getMarkersLayer().getSource().clear();
    this._hiddenMarkers = {};
    this._styleData = {};
    var _ref = state || {},
      markers = _ref.markers;
    if (markers) {
      markers.forEach(function (marker) {
        return _this8.addMapMarker(marker, null, true);
      });
    }
  },
  /**
   * Returns markers parameter for map link if any markers on map:
   * "&markers=shape|size|hexcolor|x_y|User input text___shape|size|hexcolor|x_y|input 2"
   * @return {String} link parameters
   */
  getStateParameters: function getStateParameters() {
    var _this$getState = this.getState(),
      markers = _this$getState.markers;
    return this.getMarkersString(markers);
  },
  getTransformedStateParameters: function getTransformedStateParameters(targetSrs) {
    var mapmodule = this.getMapModule();
    var currentSrs = mapmodule.getProjection();
    if (!targetSrs || targetSrs === currentSrs) {
      return this.getStateParameters();
    }
    var _this$getState2 = this.getState(),
      markers = _this$getState2.markers;
    var transformedMarkers;
    try {
      transformedMarkers = markers.map(function (marker) {
        var lonlat = mapmodule.transformCoordinates({
          lon: marker.x,
          lat: marker.y
        }, currentSrs, targetSrs);
        return _objectSpread(_objectSpread({}, marker), {}, {
          x: lonlat.lon,
          y: lonlat.lat
        });
      });
    } catch (err) {
      transformedMarkers = [];
    }
    ;
    return this.getMarkersString(transformedMarkers);
  },
  getMarkersString: function getMarkersString() {
    var markers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var FIELD = SEPARATORS.FIELD,
      MARKER = SEPARATORS.MARKER,
      COORD = SEPARATORS.COORD;
    var markerParams = markers.map(function (marker) {
      var shape = marker.shape,
        size = marker.size,
        color = marker.color,
        x = marker.x,
        y = marker.y,
        msg = marker.msg;
      var encodedMsg = encodeURIComponent(msg);
      return shape + FIELD + size + FIELD + color + FIELD + x + COORD + y + FIELD + encodedMsg;
    });
    if (markerParams.length > 0) {
      return '&markers=' + markerParams.join(MARKER);
    }
    return '';
  },
  /**
   * @method getState
   * Returns the bundle state
   * @return {Object} bundle state as JSON
   */
  getState: function getState() {
    var _this9 = this;
    if (!this.getMarkersLayer().getVisible()) {
      return {};
    }
    var markers = this.getMarkersLayer().getSource().getFeatures().map(function (feat) {
      return _this9._featureToMarkerData(feat);
    }).filter(function (markerData) {
      return !markerData.transient;
    });
    return {
      markers: markers
    };
  }
}, {
  extend: ['Oskari.mapping.mapmodule.plugin.AbstractMapModulePlugin'],
  /**
   * @static @property {string[]} protocol array of superclasses
   */
  protocol: ['Oskari.mapframework.module.Module', 'Oskari.mapframework.ui.module.common.mapmodule.Plugin']
});